import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiArrowLeft, FiCheckCircle, FiLock } from 'react-icons/fi';
import { api } from '../services/api';
import { useLocale } from '../context/LocaleContext';
import { resolveSettingMediaUrl, useSiteSettings } from '../context/SiteSettingsContext';
import './Auth.css';

const ResetPassword = () => {
  const { t } = useTranslation();
  const { localePath } = useLocale();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();
  const { settings } = useSiteSettings();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (password.length < 6) return setError(t('auth.passwordShort'));
    if (password !== confirmPassword) return setError(t('auth.passwordMismatch'));
    setSubmitting(true);
    try {
      const response = await api.post(`/api/auth/reset-password/${token}`, { password });
      setSuccess(response.message);
      window.setTimeout(() => navigate(localePath('/login'), { replace: true }), 1800);
    } catch (err) {
      setError(err.data?.message || err.message || t('auth.resetFailed'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="auth-v2-page">
      <section className="auth-v2-shell">
        <div className="auth-v2-card auth-v2-card-compact">
            <Link className="auth-v2-brand" to={localePath('/')}><img src={resolveSettingMediaUrl(settings.general.logoUrl) || '/logo/logo-login.webp'} alt={settings.general.siteTitle} /></Link>
            <header className="auth-v2-heading"><h2>{t('auth.resetTitle')}</h2><p>{t('auth.resetHint')}</p></header>
            {error && <div className="auth-v2-alert is-error" role="alert">{error}</div>}
            {success && <div className="auth-v2-alert is-success" role="status"><FiCheckCircle /> {success}</div>}
            {!success && (
              <form onSubmit={handleSubmit} className="auth-v2-form">
                <label className="auth-v2-field" htmlFor="password"><span>{t('auth.newPassword')}</span><div><FiLock />
                  <input type="password" id="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder={t('auth.passwordMinPlaceholder')} autoComplete="new-password" required />
                </div></label>
                <label className="auth-v2-field" htmlFor="confirmPassword"><span>{t('auth.confirmNewPassword')}</span><div><FiLock />
                  <input type="password" id="confirmPassword" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} placeholder={t('auth.confirmNewPlaceholder')} autoComplete="new-password" required />
                </div></label>
                <button type="submit" className="auth-v2-submit" disabled={submitting}>{submitting ? t('auth.saving') : t('auth.savePassword')}</button>
              </form>
            )}
            <Link className="auth-v2-back" to={localePath('/login')}><FiArrowLeft /> {t('auth.backLogin')}</Link>
        </div>
      </section>
    </main>
  );
};

export default ResetPassword;
